module.exports = __webpack_public_path__ + "static/media/bg-login.a9814d18.jpg";